(function() {

	angular
		.module('ngmvac')
		.filter('searchCarTypeFilter', SearchCarTypeFilter);

	function SearchCarTypeFilter() {
		return function(cars, param) {
			var items = [];
			angular.forEach(cars, function(car, index){
				if(car.tipo == param){
                    items.push(car);
                }
			});

            if(param === null){
                return cars;
            }

			return items;
		}
	}

})();